$(function(){
  $(document).on("click", ".new-sk-form-wrapper, .new-sk-form-close", function () {
    $(".new-sk-form-wrapper").removeClass("active");
  })
  $(document).on("click", ".new-sk-form-wrapper sk-form", function (e) {
    e.stopPropagation();
  })
  if($('body').attr("data-csc") != '' && $('body').attr("data-csc") != undefined){
    $(document).on("click", `${$('body').attr("data-csc")}`, function(e){
      if($(".new-sk-form-wrapper").length > 0){
        e.preventDefault();
        $(".new-sk-form-wrapper").addClass("active");
      }
    })
  }
})

  class NewFreeShippingBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init(this.dataset.added, this.dataset.shouldAdd, this.dataset.id);
  }

  init(alreadyAdded, shouldAdd, vid, alreadyAdded2, shouldAdd2, vid2) {
    console.log("initialized new free shipping bar!")
    if(shouldAdd == 'yes' && alreadyAdded == 'false'){
      let formData = new FormData();
      formData.append(`updates[${vid}]`, 1);
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(function(res){
        if(res.status){
          console.log("error");
        }
        else{
          console.log('Gift added');
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
    else if(shouldAdd == 'no' && alreadyAdded == 'true'){
      let formData = new FormData();
      formData.append(`updates[${vid}]`, 0);
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(function(res){
        if(res.status){
          console.log("error");
        }
        else{
          console.log('Gift removed');
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }
}

customElements.define('new-free-shipping-bar', NewFreeShippingBar);